import { ISanitizedCompany } from 'types/company';
import { IStory } from 'types/story';

export class StorySlugFormatError extends Error {
  name: string = 'StorySlugFormatError';
}

export const parseStorySlug = (
  storySlug: string,
): [title: string, id: string] => {
  const matches = storySlug.match(/(^[a-z\d-]+)-([a-zA-Z0-9]+)$/);

  if (!matches) {
    throw new StorySlugFormatError(`Slug "${storySlug} cannot be parsed."`);
  }

  const [, title, id] = matches;

  return [title, id];
};

export const normalizeTitle = (title: string) => {
  const normalized = title
    .toLocaleLowerCase()
    .replace(/\u00df/g, 'ss')
    .replace(/\u00e4/g, 'ae')
    .replace(/\u00f6/g, 'oe')
    .replace(/\u00fc/g, 'ue')
    .replace(/[\W_]+/g, '-')
    .replace(/^-|-$/g, '');

  return normalized || 'story';
};

interface IGetStoryUrlParams {
  story: IStory;
  company: ISanitizedCompany;
  path?: string;
}
export const getStoryPath = ({
  story,
  company,
  path = '',
}: IGetStoryUrlParams) => {
  const storySlug = normalizeTitle(story.title);

  return `/${company.slug}/${storySlug}-${story.id}${path}`;
};

export const getStoryDraftPath = ({ story, company }: IGetStoryUrlParams) => {
  return `/${company.slug}/create?draftId=${story.id}`;
};
